import _ from 'lodash';

export const selectAnnouncementForm = state => _.get(state, ['AnnouncementForm'], {});

export const selectAnnouncementFormData = state => _.get(selectAnnouncementForm(state), ['data'], {});
